// Module
var code = `<select id="enumSelect" class="form-control form-input" ng-change="ngChange({ enumerations: ngModel })" ng-options="enumeration.value as enumeration.name for enumeration in enumerations"> <option ng-show="enumerations.length > 0" value="" selected="selected"></option> </select> `;
// Exports
module.exports = code;